import http from "./axios.js";

const _url = (route, id) => `/${route}/${id}`;

const _getAll = (route) => http.get("/" + route);

const _get = (route, id) => http.get(_url(route, id));

const _delete = (route, id) => http.delete(`/${route}/${id}`);

const _edit = (route, obj) => http.patch("/" + route, obj);

const _save = (route, obj) => http.post("/" + route, obj);

const _put = (route, obj) => http.put("/" + route, obj);

const _form = (route, e, rest, edit) => {
  let data = new FormData(e);

  let props = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  Object.keys(rest).forEach((name) => {
    if (!data.has(name)) {
      const value = rest[name];
      // FormData stringifies null as "null"; send empty so API can clear optional fields.
      data.append(name, value === null || value === undefined ? "" : value);
    }
  });

  if (edit) return http.patch(`/${route}/${edit}`, data, props);

  return http.post(`/${route}`, data, props);
};

export default {
  getAll: _getAll,
  delete: _delete,
  edit: _edit,
  save: _save,
  put: _put,
  get: _get,
  form: _form,
};
